<template>
    <div class="mobile-layout" :class="[containerClass, layoutClasses]">
        <!-- 绉诲姩绔疦avBar - 鍐呯疆瀹炵幇 -->
        <header v-if="showNavBar" class="mobile-navbar" :class="navClasses">
            <div class="navbar-container">
                <button v-if="showGlobalBackButton" class="navbar-back" type="button" aria-label="返回上一级" @click="handleBack">
                    <LeftOutlined />
                    <span>返回</span>
                </button>
                <RouterLink class="navbar-brand" to="/" aria-label="返回首页">
                    <img :src="logoUrl" alt="Logo" class="logo" />
                    <span class="brand-copy">
                        <strong class="brand-name">&#40857;&#29664;&#30005;&#31454;</strong>
                        <span class="brand-subtitle">&#30495;&#27491;&#25918;&#24515;&#30340;&#21704;&#22827;&#24065;&#31199;&#36161;&#24179;&#21488;</span>
                    </span>
                </RouterLink>

                <nav class="navbar-actions" aria-label="绉诲姩绔富瀵艰埅">
                    <RouterLink class="navbar-link" :class="{ active: isHomeActive }" to="/">
                        &#39318;&#39029;
                    </RouterLink>
                    <RouterLink class="navbar-link" :class="{ active: isOrdersActive }" to="/order/list">
                        &#35746;&#21333;
                    </RouterLink>
                    <RouterLink class="navbar-link" :class="{ active: isProfileActive }" to="/profile/center">
                        &#25105;&#30340;
                    </RouterLink>
                </nav>
            </div>
        </header>

        <!-- 涓诲唴瀹瑰尯鍩?-->
        <main class="mobile-main-content" :class="contentClasses">
            <slot />
        </main>

        <!-- 绉诲姩绔疶abBar - 鍐呯疆瀹炵幇 -->
        <footer v-if="showTabBar" class="mobile-tabbar" :class="tabBarClasses">
            <div class="tabbar-container">
                <div v-for="item in tabBarItems" :key="item.key" class="tabbar-item"
                    :class="{ 'tabbar-item--active': item.key === activeTabKey }" @click="handleTabClick(item)">
                    <div class="tabbar-icon">
                        <component :is="item.icon" />
                    </div>
                    <span class="tabbar-label">{{ item.label }}</span>
                </div>
            </div>
        </footer>

        <!-- 鍐呭閬僵锛堝彲閫夛紝鐢ㄤ簬妯℃€佺姸鎬侊級 -->
        <div v-if="showOverlay" class="mobile-overlay" @click="$emit('overlay-click')" />

        <div class="mobile-side-actions">
            <button v-if="showMobileSupportEntry" type="button" class="mobile-support-entry" aria-label="在线客服" @click="router.push('/support')">
                <span>客服</span>
            </button>
            <NoticeFloatingButton
                mobile
                :has-companion="showMobileSupportEntry"
                :action-footer="hasActionFooter"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRouter, useRoute } from 'vue-router'
// 绉诲姩绔笉闇€瑕佺敤鎴蜂俊鎭浉鍏崇殑瀵煎叆
import { useAuthStore } from '@/stores'
import NoticeFloatingButton from '@/components/common/NoticeFloatingButton.vue'
import logoUrl from '@/assets/logo.jpg'
import {
    HomeOutlined,
    UserOutlined,
    FileTextOutlined,
    LeftOutlined
} from '@ant-design/icons-vue'

interface TabBarItem {
    key: string
    label: string
    icon: unknown
    path: string
}

interface Props {
    // UI鎺у埗
    showNavBar?: boolean
    showTabBar?: boolean

    // NavBar閰嶇疆
    navTitle?: string
    showBack?: boolean
    showLogo?: boolean
    navMode?: 'default' | 'transparent' | 'minimal'
    navBackgroundColor?: string

    // TabBar閰嶇疆
    customTabBarItems?: TabBarItem[]

    // 瀹夊叏鍖哄煙
    safeAreaTop?: boolean
    safeAreaBottom?: boolean

    // 鏍峰紡鎺у埗
    backgroundColor?: string
    containerClass?: string

    // Special state.
    showOverlay?: boolean
    fullScreen?: boolean
    noPadding?: boolean
    autoHeight?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    showNavBar: true,
    showTabBar: false,
    navTitle: '',
    showBack: false,
    showLogo: false,
    navMode: 'default',
    navBackgroundColor: '',
    customTabBarItems: () => [],
    safeAreaTop: true,
    safeAreaBottom: true,
    backgroundColor: 'var(--app-global-background)',
    containerClass: '',
    showOverlay: false,
    fullScreen: false,
    noPadding: false,
    autoHeight: false
})

defineEmits<{
    'overlay-click': []
}>()

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()

// 榛樿TabBar閰嶇疆
const defaultTabBarItems: TabBarItem[] = [
    {
        key: 'home',
        label: '首页',
        icon: HomeOutlined,
        path: '/'
    },
    {
        key: 'orders',
        label: '订单',
        icon: FileTextOutlined,
        path: '/order/list'
    },
    {
        key: 'profile',
        label: '我的',
        icon: UserOutlined,
        path: '/profile/center'
    }
]

// 璁＄畻TabBar椤圭洰
const tabBarItems = computed(() => {
    return props.customTabBarItems.length > 0 ? props.customTabBarItems : defaultTabBarItems
})

// 璁＄畻褰撳墠婵€娲荤殑Tab
const isHomeActive = computed(() => route.path === '/')
const showGlobalBackButton = computed(() => route.path !== '/')
const isOrdersActive = computed(() => route.path.startsWith('/order'))
const isProfileActive = computed(() => route.path.startsWith('/profile'))
const showMobileSupportEntry = computed(() => (
    authStore.isAuthenticated &&
    !authStore.canAccessAdmin &&
    route.path !== '/support' &&
    !route.path.startsWith('/admin')
))
const hasActionFooter = computed(() => (
    route.path === '/account/publish' || route.path.startsWith('/account/detail/')
))

const activeTabKey = computed(() => {
    const path = route.path
    const activeItem = tabBarItems.value.find(item => {
        if (item.path === '/' && path === '/') return true
        if (item.path !== '/' && path.startsWith(item.path)) return true
        return false
    })
    return activeItem?.key || ''
})

// Mobile layout classes.
const layoutClasses = computed(() => ({
    'mobile-layout--full-screen': props.fullScreen,
    'mobile-layout--with-navbar': props.showNavBar,
    'mobile-layout--with-tabbar': props.showTabBar,
    'mobile-layout--safe-area-top': props.safeAreaTop,
    'mobile-layout--safe-area-bottom': props.safeAreaBottom,
    'mobile-layout--no-padding': props.noPadding,
    'mobile-layout--auto-height': props.autoHeight,
    'mobile-layout--action-footer': hasActionFooter.value
}))

// Mobile content classes.
const contentClasses = computed(() => ({
    'mobile-main-content--with-navbar': props.showNavBar,
    'mobile-main-content--with-tabbar': props.showTabBar,
    'mobile-main-content--full-screen': props.fullScreen,
    'mobile-main-content--no-padding': props.noPadding,
    'mobile-main-content--safe-top': props.safeAreaTop && props.showNavBar,
    'mobile-main-content--safe-bottom': props.safeAreaBottom && props.showTabBar
}))

// Mobile navbar classes.
const navClasses = computed(() => ({
    'navbar--transparent': props.navMode === 'transparent',
    'navbar--minimal': props.navMode === 'minimal'
}))

// Mobile tabbar classes.
const tabBarClasses = computed(() => ({
    'tabbar--safe-area': props.safeAreaBottom
}))

// 涓氬姟鏂规硶
const handleBack = () => {
    // 鐗规畩澶勭悊锛氳鍗曡鎯呴〉闈㈣繑鍥炲埌璁㈠崟鍒楄〃
    if (route.name === 'order-detail') {
        router.push('/order/list')
        return
    }

    if (window.history.state?.back) {
        router.back()
        return
    }

    router.push('/')
}

const handleTabClick = (item: TabBarItem) => {
    if (route.path !== item.path) {
        router.push(item.path)
    }
}
// ==================== 鐢ㄦ埛淇℃伅璁＄畻灞炴€?====================
// 绉诲姩绔笉鏄剧ず鐢ㄦ埛澶村儚锛岀浉鍏宠绠楀睘鎬у凡绉婚櫎
</script>
<style lang="less" scoped>
.mobile-layout {
    min-height: 100vh;
    background: v-bind(backgroundColor);
    position: relative;
    display: flex;
    flex-direction: column;

    // 鑷姩楂樺害妯″紡
    &.mobile-layout--auto-height {
        min-height: auto;
    }

    // 瀹夊叏鍖哄煙鏀寔 - 鐜板湪鐢盢avBar鍜孴abBar澶勭悊
    &.mobile-layout--safe-area-top {
        .mobile-navbar {
            padding-top: env(safe-area-inset-top);
        }
    }

    &.mobile-layout--safe-area-bottom {
        .mobile-tabbar {
            padding-bottom: env(safe-area-inset-bottom);
        }
    }

    // 鍏ㄥ睆妯″紡
    &.mobile-layout--full-screen {
        height: 100vh;
        overflow: hidden;

        .mobile-main-content {
            height: 100%;
            overflow-y: auto;
        }
    }
}

// NavBar鏍峰紡
.mobile-navbar {
    background: rgba(2, 6, 23, 0.9);
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow:
        0 14px 44px rgba(0, 0, 0, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1000;

    &.navbar--transparent {
        background: transparent;
        box-shadow: none;
    }

    &.navbar--minimal {
        box-shadow: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    .navbar-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px;
        height: 52px;
    }

    .navbar-left {
        min-width: 60px;

        .back-btn {
            padding: 4px 8px;
            font-size: 18px;
            color: white;

            &:hover {
                color: white;
                background: rgba(255, 255, 255, 0.12);
            }
        }

        .logo-section {
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            padding: 6px 10px;
            margin: -6px -10px;
            border-radius: 12px;
            transition: transform 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;

            &:hover {
                background: rgba(255, 255, 255, 0.12);
                box-shadow: 0 12px 26px rgba(0, 0, 0, 0.22);
                transform: translate3d(0, -1px, 0);
            }

            .logo {
                height: 28px;
                width: auto;
            }

            .brand-name {
                font-size: 16px;
                font-weight: 600;
                color: white;
                text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            }
        }
    }

    .navbar-center {
        flex: 1;
        text-align: center;

        .nav-title {
            font-size: 16px;
            font-weight: 600;
            color: white;
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }
    }

    .navbar-right {
        min-width: 60px;
        display: flex;
        justify-content: flex-end;
        gap: 8px;


    }
}

.mobile-main-content {
    flex: 1;
    min-height: 0;
    position: relative;
    padding: 8px;
    z-index: 1;
    /* 纭繚鍐呭鍦ㄨ儗鏅箣涓?*/

    // 鏈塏avBar鏃剁殑椤堕儴闂磋窛
    &.mobile-main-content--with-navbar {
        padding-top: calc(52px + 8px); // NavBar楂樺害52px + 鍐呭闂磋窛8px
    }

    // 鏈塗abBar鏃剁殑搴曢儴闂磋窛
    &.mobile-main-content--with-tabbar {
        padding-bottom: calc(60px + 8px); // TabBar楂樺害60px + 鍐呭闂磋窛8px
    }

    // 瀹夊叏鍖哄煙璋冩暣
    &.mobile-main-content--safe-top {
        padding-top: calc(52px + 8px + env(safe-area-inset-top));
    }

    &.mobile-main-content--safe-bottom {
        padding-bottom: calc(60px + 8px + env(safe-area-inset-bottom));
    }

    &.mobile-main-content--full-screen {
        padding: 0;
        height: 100%;
    }

    // 鏃犲唴杈硅窛妯″紡
    &.mobile-main-content--no-padding {
        padding-left: 0;
        padding-right: 0;

        &.mobile-main-content--with-navbar {
            padding-top: 52px; // 鍙繚鐣橬avBar楂樺害锛屽幓鎺夐澶栫殑12px闂磋窛
        }

        &.mobile-main-content--with-tabbar {
            padding-bottom: 60px; // 鍙繚鐣橳abBar楂樺害锛屽幓鎺夐澶栫殑12px闂磋窛
        }

        // 瀹夊叏鍖哄煙璋冩暣
        &.mobile-main-content--safe-top {
            padding-top: calc(52px + env(safe-area-inset-top));
        }

        &.mobile-main-content--safe-bottom {
            padding-bottom: calc(60px + env(safe-area-inset-bottom));
        }
    }
}

.mobile-tabbar {
    background: rgba(15, 23, 42, 0.82);
    border-top: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow:
        0 -14px 44px rgba(0, 0, 0, 0.3),
        0 -6px 18px rgba(0, 0, 0, 0.14),
        inset 0 1px 0 rgba(255, 255, 255, 0.08);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1000;

    // 瀹夊叏鍖哄煙宸插湪涓婇潰鐨勫竷灞€绾у埆澶勭悊锛岃繖閲岀Щ闄ら噸澶嶈缃?
    .tabbar-container {
        display: flex;
        height: 60px;
    }

    .tabbar-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 2px;
        cursor: pointer;
        transition: all 0.2s ease;

        &:active {
            background: rgba(255, 255, 255, 0.1);
        }

        .tabbar-icon {
            font-size: 20px;
            color: rgba(255, 255, 255, 0.7);
            transition: color 0.2s;
        }

        .tabbar-label {
            font-size: 10px;
            color: rgba(255, 255, 255, 0.7);
            transition: color 0.2s;
        }

        &.tabbar-item--active {

            .tabbar-icon,
            .tabbar-label {
                color: white;
                text-shadow: 0 0 8px rgba(255, 255, 255, 0.5);
            }
        }
    }
}

.mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

@media (max-width: 375px) {
    .mobile-main-content {
        padding: 6px;
    }

    .mobile-navbar {
        .navbar-container {
            padding: 0 12px;
        }
    }

    .mobile-tabbar {
        .tabbar-item {
            .tabbar-icon {
                font-size: 18px;
            }

            .tabbar-label {
                font-size: 9px;
            }
        }
    }
}

// 妯睆閫傞厤
@media (orientation: landscape) and (max-height: 500px) {
    .mobile-layout {
        &.mobile-layout--safe-area-top {
            padding-top: 0;
        }
    }

    .mobile-navbar {
        .navbar-container {
            height: 48px;
        }
    }

    .mobile-tabbar {
        .tabbar-container {
            height: 54px;
        }
    }
}

// 鐗规畩椤甸潰鏍峰紡
.mobile-layout.login-page {
    background: linear-gradient(135deg, #05070c 0%, #0b1220 42%, #111827 100%);
}

.mobile-layout.modal-page {
    .mobile-main-content {
        background: white;
        border-radius: 12px 12px 0 0;
        margin-top: 20px;
    }
}

/* Global mobile top navigation: always keep Home and Publish reachable. */
.mobile-layout {
    --mobile-global-nav-height: 78px;
    --mobile-global-nav-accent: #ffd5e4;
}

.mobile-navbar {
    background: rgba(255, 255, 255, 0.98) !important;
    border-bottom: 8px solid var(--mobile-global-nav-accent) !important;
    box-shadow: 0 10px 28px rgba(2, 6, 23, 0.08) !important;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);

    &.navbar--transparent,
    &.navbar--minimal {
        background: rgba(255, 255, 255, 0.98) !important;
        border-bottom: 8px solid var(--mobile-global-nav-accent) !important;
        box-shadow: 0 10px 28px rgba(2, 6, 23, 0.08) !important;
    }

    .navbar-container {
        height: var(--mobile-global-nav-height);
        padding: 0 clamp(8px, 2.6vw, 14px);
        gap: clamp(8px, 2.4vw, 16px);
        justify-content: space-between;
        min-width: 0;
    }
}

.navbar-brand {
    min-width: 0;
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: left;
    text-decoration: none;
    cursor: pointer;
    overflow: hidden;
}

.navbar-back {
    flex: 0 0 auto;
    min-width: 44px;
    height: 36px;
    padding: 0 8px;
    border: 0;
    border-radius: 999px;
    background: rgba(15, 23, 42, 0.06);
    color: #111827;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-size: 13px;
    line-height: 1;
    font-weight: 900;
    white-space: nowrap;
    cursor: pointer;
}

.navbar-back :deep(.anticon) {
    font-size: 13px;
}

.navbar-brand .logo {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    border-radius: 12px;
    object-fit: cover;
}

.brand-copy {
    min-width: 0;
    display: grid;
    gap: 2px;
    overflow: hidden;
}

.brand-name {
    color: #111827;
    font-size: clamp(19px, 5.2vw, 28px);
    line-height: 1;
    font-weight: 950;
    letter-spacing: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.brand-subtitle {
    color: #111827;
    font-size: clamp(10px, 2.75vw, 13px);
    line-height: 1.1;
    font-weight: 750;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.navbar-actions {
    flex: 0 0 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: clamp(8px, 2.8vw, 18px);
    height: 100%;
}

.navbar-link {
    height: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    color: #111827;
    display: flex;
    align-items: center;
    font-size: clamp(14px, 3.8vw, 18px);
    line-height: 1;
    font-weight: 900;
    white-space: nowrap;
    text-decoration: none;
    cursor: pointer;
    letter-spacing: 0;
}

.navbar-link.active {
    color: #020617;
    font-weight: 950;
}

.navbar-link:active,
.navbar-brand:active {
    transform: translateY(1px);
}

.mobile-main-content.mobile-main-content--with-navbar {
    padding-top: calc(var(--mobile-global-nav-height) + 14px);
}

.mobile-main-content.mobile-main-content--safe-top {
    padding-top: calc(var(--mobile-global-nav-height) + 14px + env(safe-area-inset-top));
}

.mobile-main-content.mobile-main-content--no-padding.mobile-main-content--with-navbar {
    padding-top: var(--mobile-global-nav-height);
}

.mobile-main-content.mobile-main-content--no-padding.mobile-main-content--safe-top {
    padding-top: calc(var(--mobile-global-nav-height) + env(safe-area-inset-top));
}

@media (max-width: 380px) {
    .mobile-layout {
        --mobile-global-nav-height: 70px;
    }

    .mobile-navbar .navbar-container {
        gap: 8px;
        padding: 0 9px;
    }

    .navbar-brand .logo {
        width: 36px;
        height: 36px;
        flex-basis: 36px;
    }

    .navbar-actions {
        gap: 10px;
    }

    .navbar-link {
        font-size: 13px;
    }

    .navbar-back {
        min-width: 32px;
        width: 32px;
        height: 32px;
        padding: 0;
    }

    .navbar-back span {
        display: none;
    }

    .brand-subtitle {
        display: none;
    }
}

.mobile-side-actions {
    position: fixed;
    right: 14px;
    bottom: calc(82px + env(safe-area-inset-bottom));
    z-index: 1002;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.mobile-support-entry {
    position: relative;
    width: 48px;
    height: 48px;
    padding: 0;
    border: 1px solid rgba(56, 189, 248, 0.48);
    border-radius: 50%;
    background:
        radial-gradient(120% 160% at 0 0, rgba(45, 212, 191, 0.28), transparent 58%),
        linear-gradient(135deg, rgba(14, 165, 233, 0.96), rgba(15, 23, 42, 0.96));
    color: #f8fafc;
    font-size: 12px;
    font-weight: 900;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 14px 34px rgba(2, 6, 23, 0.42);
}

.mobile-side-actions :deep(.site-notice-entry--mobile) {
    position: relative;
    top: auto;
    right: auto;
    bottom: auto;
    flex: 0 0 auto;
}

.mobile-support-entry span {
    display: inline-block;
    font-size: 12px;
    font-weight: 900;
    line-height: 1.1;
    letter-spacing: 0;
}

.mobile-layout--action-footer .mobile-side-actions {
    bottom: calc(116px + env(safe-area-inset-bottom));
}

@media (max-width: 380px) {
    .mobile-side-actions {
        right: 10px;
        gap: 8px;
    }

    .mobile-support-entry {
        width: 44px;
        height: 44px;
    }
}
</style>

